import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../../../../types/super-cut-field'
import CreationCaptureSegmentationTypeField from '../../../../../form-fields/super-cut/segmentation-type'
import { CreationCaptureInfoContext } from '../manager'

const SegmentationType = styled(CreationCaptureSegmentationTypeField)`
    grid-column: span 2;
`

type Props = {
    className?: string
    field: CreationToolSuperCutField
}

const CreationCaptureInfoSegmentationTypeField = ({ className, field }: Props) => {
    const { segmentationType, setSegmentationType, caption, hasAutoCaption } = useContext(CreationCaptureInfoContext)

    return (
        <SegmentationType
            {...{
                className,
                field,
                defaultSegmentationType: segmentationType,
                hasCaptionsFile: caption !== undefined || hasAutoCaption,
                onChange: setSegmentationType,
            }}
        />
    )
}

export default CreationCaptureInfoSegmentationTypeField
